import { render, staticRenderFns } from "./acceptList.vue?vue&type=template&id=5dc48632&scoped=true&"
import script from "./acceptList.vue?vue&type=script&lang=js&"
export * from "./acceptList.vue?vue&type=script&lang=js&"
import style0 from "./acceptList.vue?vue&type=style&index=0&id=5dc48632&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc48632",
  null
  
)

export default component.exports